module.exports = __webpack_public_path__ + "8edb7e7696a23b0225ce5ace095d4eff.pdf";